<template>
  <div class="conversations">
    <div v-for="conversation in conversations" v-bind:key="conversation.id">
      <a v-bind:href="'/' + conversation.id">{{ conversation.id }}</a>
    </div>
  </div>
</template>

<script>
import { db } from '../db'

export default {
  name: 'ConversationList',

  data() {
    return {
      conversations: [],
    }
  },

  firestore: {
    conversations: db.collection('conversations'),
  }
}
</script>

<style scoped>
.conversations {
  padding: 20px 40px;
  line-height: 2em;
}
</style>
